import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  FileText,
  Users,
  BookOpen,
  // UserCircle,
  // CreditCard,
  // BarChart3,
  // Settings,
  LogOut,
  // ChevronLeft,
  // ChevronRight,
  Bell,
  Award,
  Info,
  Download,
  Mail,
  Lock,
  X
} from 'lucide-react';
import './AdminSidebar.css';

const AdminSidebar = ({ isOpen, onToggle, isMobile }) => {
  const navigate = useNavigate();

  const menuItems = [
    {
      path: '/admin/dashboard',
      icon: LayoutDashboard,
      label: 'Dashboard'
    },
    {
      path: '/admin/general-info',
      icon: Info,
      label: 'General Info'
    },
    {
      path: '/admin/downloads',
      icon: Download,
      label: 'Downloads',
      badgeType: 'number'
    },
    {
      path: '/admin/online-submissions',
      icon: FileText,
      label: 'Online Submissions',
      badgeType: 'number'
    },
    {
      path: '/admin/reviewer-submissions',
      icon: Users,
      label: 'Reviewer Submissions'
    },
    {
      path: '/admin/call-for-papers',
      icon: FileText,
      label: 'Call for Papers/Marquee'
    },
    {
      path: '/admin/journal-metrics',
      icon: Award,
      label: 'Journal Metrics'
    },
    {
      path: '/admin/journal-volumes',
      icon: BookOpen,
      label: 'Journal Volumes'
    },
    {
      path: '/admin/editorial-board',
      icon: Users,
      label: 'Editorial Board',
      badgeType: 'text'
    },
    {
      path: '/admin/contacts',
      icon: Mail,
      label: 'Contacts'
    },
    {
      path: '/admin/notifications',
      icon: Bell,
      label: 'Notifications'
    },
    {
      path: '/admin/change-password',
      icon: Lock,
      label: 'Change Password'
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const handleNavClick = () => {
    if (isMobile) {
      onToggle();
    }
  };
  const isDarkMode = localStorage.getItem("darkMode");

  return (
    <>
      <aside className={`admin-sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="logo-icon">
              <img src={isDarkMode ? '/images/ijacna-logoo.png' : '/images/ijacna-logo.jpg'} className='logo-img' alt="IJACNA Logo" />
            </div>
            {!isMobile && isOpen && (
              <div className="logo-text">
                <span className="brand-name">IJACNA</span>
              </div>
            )}
          </div>
          {isMobile && isOpen && (
            <button className="sidebar-close-btn" onClick={onToggle}>
              <X size={20} />
            </button>
          )}
          {/* {!isMobile && (
            <button className="sidebar-toggle" onClick={onToggle}>
              {isOpen ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
            </button>
          )} */}
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={index}
                to={item.path}
                onClick={handleNavClick}
                className={({ isActive }) =>
                  `nav-item ${isActive ? 'active' : ''}`
                }
              >
                <span className="nav-icon">
                  <Icon size={17} />
                </span>

                {isOpen && (
                  <>
                    <span className="nav-label">{item.label}</span>
                    {item.badge && (
                      <span className={`nav-badge ${item.badgeType}`}>
                        {item.badge}
                      </span>
                    )}
                  </>
                )}

                {!isOpen && item.badge && (
                  <span className={`nav-badge collapsed ${item.badgeType}`}>
                    {item.badgeType === 'number' ? item.badge : ''}
                  </span>
                )}
              </NavLink>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          {isOpen ? (
            <button className="logout-btn" onClick={handleLogout}>
              <LogOut size={16} />
              <span>Sign Out</span>
            </button>
          ) : (
            <button className="logout-btn collapsed" onClick={handleLogout} title="Sign Out">
              <LogOut size={16} />
            </button>
          )}
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;